import { z } from 'zod';
import { buildRecipeWithCategoriesSchema } from './BaseRecipeSchema';
export const buildCreateRecipeByTextRequestSchema = (recipeCategories = []) => z.object({
    recipe: buildRecipeWithCategoriesSchema(recipeCategories),
});
export const CreateRecipeByTextRequestSchema = buildCreateRecipeByTextRequestSchema();
//# sourceMappingURL=CreateRecipeByTextRequestSchema.js.map